// extracted by mini-css-extract-plugin
export default {"pagination__container":"pagination_pagination__container__YkXBI","pagination__text":"pagination_pagination__text__KsItc","pagination__btn":"pagination_pagination__btn__crhSD"};